
import React from 'react';
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { UseFormReturn } from 'react-hook-form';
import { SharedFormField } from './SharedFormField';

interface DateFieldProps<T> {
  name: string;
  label: string;
  form: UseFormReturn<T>;
  disabled?: boolean;
  description?: string;
}

export const DateField = <T extends Record<string, any>>({
  name,
  label,
  form,
  disabled = false,
  description
}: DateFieldProps<T>) => {
  
  return (
    <SharedFormField
      name={name}
      label={label}
      form={form}
      className="flex flex-col"
      description={description}
    >
      {(field) => (
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                "w-full pl-3 text-left font-normal",
                !field.value && "text-muted-foreground"
              )}
              disabled={disabled}
            >
              <CalendarIcon className="mr-2 h-4 w-4 opacity-50" />
              {field.value ? (
                format(field.value, "PPP")
              ) : (
                <span>Pick a date</span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={field.value}
              onSelect={field.onChange}
              disabled={disabled}
              initialFocus
              className="rounded-md border p-3 pointer-events-auto"
            />
          </PopoverContent>
        </Popover>
      )}
    </SharedFormField>
  );
};
